import _DoubleChevronRightIcon from "@adsk/alloy-react-icon/es/lib/DoubleChevronRightIcon";
import _ChevronRightIcon from "@adsk/alloy-react-icon/es/lib/ChevronRightIcon";
import _ChevronLeftIcon from "@adsk/alloy-react-icon/es/lib/ChevronLeftIcon";
import _DoubleChevronLeftIcon from "@adsk/alloy-react-icon/es/lib/DoubleChevronLeftIcon";
import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-locale';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import PaginationButton from './PaginationButton';
import getTableTheme from '../helpers/getTableTheme';
const PaginationFooter = _ref => {
  let {
    canPreviousPage,
    canNextPage,
    setPageIndex,
    pageIndex,
    pageSize,
    pageCount,
    totalDataCount,
    tableSize,
    style,
    className,
    text
  } = _ref;
  const tableSizeTheme = getTableTheme(tableSize);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  const displayText = useMemo(() => {
    return text || T.translate('SHOWING', {
      itemRangeStart: pageSize * pageIndex + 1,
      itemRangeEnd: Math.min(pageSize * pageIndex + pageSize, totalDataCount),
      itemCount: totalDataCount
    });
  }, [text, T, pageSize, pageIndex, totalDataCount]);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    $_css: [{
      position: 'sticky',
      bottom: 0,
      left: 0,
      backgroundColor: theme.tokens.colors.background.primary.value,
      borderTop: "1px solid ".concat(theme.tokens.colors.border.subtle.value),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minHeight: tableSizeTheme.rowHeight,
      padding: "0 ".concat(tableSizeTheme.cellPadding, "px")
    }, style]
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: theme.tokens.colors.text.secondary.value
    }
  }, displayText), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      display: 'flex',
      alignItems: 'center'
    }]
  }, /*#__PURE__*/React.createElement(PaginationButton, {
    "data-testid": "pagination-first-page",
    disabled: !canPreviousPage,
    renderIcon: useCallback(() => /*#__PURE__*/React.createElement(_DoubleChevronLeftIcon, null), []),
    onClick: () => setPageIndex(0),
    style: {
      marginRight: theme.spacing.XXS
    }
  }), /*#__PURE__*/React.createElement(PaginationButton, {
    "data-testid": "pagination-previous-page",
    disabled: !canPreviousPage,
    renderIcon: useCallback(() => /*#__PURE__*/React.createElement(_ChevronLeftIcon, null), []),
    onClick: () => setPageIndex(pageIndex - 1)
  }), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: [{
      margin: "0 ".concat(theme.spacing.S, "px")
    }]
  }, T.translate('PAGE_COUNT', {
    currentPage: pageIndex + 1,
    totalPages: pageCount
  })), /*#__PURE__*/React.createElement(PaginationButton, {
    "data-testid": "pagination-next-page",
    disabled: !canNextPage,
    renderIcon: useCallback(() => /*#__PURE__*/React.createElement(_ChevronRightIcon, null), []),
    onClick: () => setPageIndex(pageIndex + 1)
  }), /*#__PURE__*/React.createElement(PaginationButton, {
    "data-testid": "pagination-last-page",
    disabled: !canNextPage,
    renderIcon: useCallback(() => /*#__PURE__*/React.createElement(_DoubleChevronRightIcon, null), []),
    onClick: () => setPageIndex(pageCount - 1),
    style: {
      marginLeft: theme.spacing.XXS
    }
  })));
};
PaginationFooter.propTypes = {
  canPreviousPage: PropTypes.bool.isRequired,
  canNextPage: PropTypes.bool.isRequired,
  pageCount: PropTypes.number.isRequired,
  setPageIndex: PropTypes.func.isRequired,
  state: PropTypes.shape({
    pageIndex: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    totalDataCount: PropTypes.number.isRequired
  }),
  style: stylePropType
};
export default PaginationFooter;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), p => p.$_css2);
var _StyledDiv3 = _styled3("div").withConfig({
  displayName: "PaginationFooter___StyledDiv3",
  componentId: "sc-u8436i-0"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=PaginationFooter.js.map